(function () {
  RequestPasswordController.$inject = ["apiService", "$scope"];
  app.controller('RequestPasswordController', RequestPasswordController);

  function RequestPasswordController(apiService, $scope) {
    $scope.show = { 'requested': false, 'request': true };
    $scope.user = { login: undefined };
    $scope.errors = {};
    $scope.submittedEmail;

    $scope.save = function (userForm) {
      userForm.submitted = true;
      if (userForm.$valid && $scope.submittedEmail !== $scope.user.login) {
        var dataObj = { 'login': $scope.user.login };

        $scope.errors.serverError = false;
        $scope.submittedEmail = angular.copy($scope.user.login);

        apiService.postSome('resetpassword/request', dataObj, $scope.user)
        .then(function () {
          $scope.show.requested = true;
          $scope.show.request = false;
        }, function (err) {
          if (err[0].errorKey === 'ERROR_NOT_EXISTED_EMAIL') {
            // eslint-disable-next-line max-len
            $scope.errors.serverError = 'We do not recognize the email address you entered. Please try again.';
          }
        });
      }
    };

    $scope.validateForm = function (userForm) {
      return Boolean((userForm.submitted || (userForm.email && userForm.email.$touched)) &&
      (!userForm.$valid || $scope.errors.serverError && $scope.submittedEmail === $scope.user.login)
    );
    };
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/apps/password/requestPasswordController.js